import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-143225c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 text-center shadow-lg w-4/5 m-auto min-h-fit p-8 justify-items-center my-6 rounded-md" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-left h-full md:px-3 md:w-full flex justify-center flex-col col-span-2" }
const _hoisted_4 = { class: "font-weight-bold" }
const _hoisted_5 = { class: "input-width" }
const _hoisted_6 = { class: "grey-text text-left text-xs mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        src: _ctx.tile.thumbnail,
        style: {"width":"200px","height":"120px","background-color":"#ffffff"}
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.tile.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.tile.key), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("Površina")), 1),
      _createVNode(_component_a_form_item, {
        name: [_ctx.index, 'quantity'],
        rules: {
                   required: true,
                   trigger: 'change',
                   validator: _ctx.validateArea
                 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.tile.quantity,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tile.quantity) = $event)),
            onBlur: _ctx.saveFootage,
            style: {"height":"40px","border-radius":"6px"},
            class: "m-auto hideStepper",
            type: "number",
            min: "0",
            placeholder: _ctx.$t('Vpiši kvadraturo'),
            suffix: "m2"
          }, null, 8, ["value", "onBlur", "placeholder"])
        ]),
        _: 1
      }, 8, ["name", "rules"])
    ])
  ]))
}